import { cn } from "@omni/utils/styles";

import { useUspContext } from "@/components/Blocks/usps/components/context/usp.context";

type Props = { className?: string };

export const Text = ({ className }: Props) => {
    const { usp } = useUspContext();

    return (
        <p
            className={cn(
                {
                    "tw:hover:underline": !!usp.link
                },
                className
            )}
        >
            {usp.text}
        </p>
    );
};
